import React from "react";
import { styles } from "./PublicLinksTable.styles";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import UniversalTable from "../UniversalTable/UniversalTable";
import { IUniversalTableColumn, IUniversalTableData } from "../UniversalTable/interfaces";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import * as PublicLinkAction from "../../../stores/publicLinks/PublicLinkAction";
import PublicLinkModel from "../../../models/publicLink/PublicLinkModel";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import ToastStatusEnum from "../../../constants/ToastStatusEnum";
import AddBoxIcon from '@material-ui/icons/AddBox';
import configuration from "../../../utilities/configuration";

export interface IPublicLinksTableProps extends WithStyles<typeof styles> {
    orderId: any;
    onAddPublicLink: any;
    publicLinksFromState: any;
    isRequesting: any;
}

const PublicLinksTablePure: React.FunctionComponent<IPublicLinksTableProps> = ({ orderId, onAddPublicLink, publicLinksFromState, isRequesting, classes }: IPublicLinksTableProps) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const {enqueueSnackbar} = useSnackbar();

    let publicLinks: IUniversalTableData;

    if (publicLinksFromState) {
        publicLinks = Object.values(publicLinksFromState)?.map((publicLink: PublicLinkModel) => ({
            id: publicLink.id,
            link: `${configuration.externalUrl}/download/${publicLink.id}`,
            expiration: publicLink.expiration

        }));
    }
    const onRowClick = row => {
        let path = "/download/" + publicLinks[row].id;
        history.push(path);
    };

    const hanldleCopyToClipboard = (index) => {
        const link = publicLinks[index]?.link as string;
        navigator.clipboard.writeText(link);
        enqueueSnackbar("Link coppied to clipboard", {
            variant: ToastStatusEnum.Info
        })
    }

    const handleDeleteFinished = (index) => {
        dispatch(PublicLinkAction.deletePublicLink(publicLinks[index]?.id)).then(() => {
            enqueueSnackbar("Link deleted", {
                variant: ToastStatusEnum.Info
            })
            dispatch(PublicLinkAction.requestPublicLinks(orderId));
        })
    }

    const handleAddFinished = () => {
        onAddPublicLink(true);
    }

    const columns: IUniversalTableColumn[] = [
        {
            type: "link",
            title: "Link",
            field: "link",
            onClick: index => onRowClick(index)
        },
        {
            type: "dateTime",
            title: "Expires At",
            field: "expiration"
        },
        {
            type: "actions",
            title: "Actions",
            actions: [
                {
                    name: "copyLink",
                    icon: <FileCopyIcon />,
                    tooltip: "Copy to clipboard",
                    onClick: index => hanldleCopyToClipboard(index)
                },
                {
                    name: "delete",
                    tooltip: "Delete",
                    onDeleteFinished: index => handleDeleteFinished(index),
                    deleteQuestion: "Do you want to delete this public link?"
                },
                {
                    name: "addLink",
                    icon: <AddBoxIcon />,
                    tableAction: true,
                    tooltip: "Add public link",
                    onClick: () => handleAddFinished()
                }
            ]
        }
    ];
    return (
        <div className={classes.section}>
            <UniversalTable columns={columns} data={publicLinks} isLoading={isRequesting} />
        </div>
    );
};

export const PublicLinksTable = withStyles(styles)(PublicLinksTablePure);
